import { useState, useEffect } from "react";
import { getMADetailWiseBalanceQty } from "../services/productionService";

const useGetMAWiseBalancePlanQty = () => {
    const [maWiseDetail, setMAWiseDetail] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [loading, setLoading] = useState(true);  // Add loading state here

    const fetchAllAvailableMABalanceQty = async (payload) => {
        // const p_companyid = localStorage.getItem('companyid');
        // const today = new Date();
        // const oneWeekAgo = new Date();
        // oneWeekAgo.setDate(today.getDate() - 7);

        // const para = {
        //     p_companyid: p_companyid,
        //     p_plantid: 1,
        //     p_frommodate: oneWeekAgo.toISOString(), // ISO format for PostgreSQL timestamp
        //     p_tomodate: today.toISOString(),
        //     p_mode: 0,
        // };

        try {
            const data = await getMADetailWiseBalanceQty(payload);
            if (data) {
                setMAWiseDetail(data);
                setIsDataLoaded(true);
            }
        } catch (error) {
            console.error(error.message);
        } finally {
            setLoading(false);  // Set loading to false after data is fetched
        }
    }

    const loadDetailWithoutDate = async (payload) => {
        await fetchAllAvailableMABalanceQty(payload);
    }

    const loadDetailWithDate = async (payload) => {
        await fetchAllAvailableMABalanceQty(payload);
    }


    // useEffect(() => {
    //     const fetchData = async () => {
    //         const p_companyid = localStorage.getItem('companyid');
    //         const today = new Date();
    //         const oneWeekAgo = new Date();
    //         oneWeekAgo.setDate(today.getDate() - 7);

    //         const para = {
    //             p_companyid: p_companyid,
    //             p_plantid: 1,
    //             p_frommodate: oneWeekAgo.toISOString(), // ISO format for PostgreSQL timestamp
    //             p_tomodate: today.toISOString(),
    //             p_mode: 0,
    //         };

    //         try {
    //             const data = await getMADetailWiseBalanceQty(para);
    //             if (data) {
    //                 setMAWiseDetail(data);
    //                 setIsDataLoaded(true);
    //             }
    //         } catch (error) {
    //             console.error(error.message);
    //         } finally {
    //             setLoading(false);  // Set loading to false after data is fetched
    //         }
    //     };

    //     fetchData();
    // }, [isDataLoaded]);  // This hook will run once when the component mounts

    return { maWiseDetail, setMAWiseDetail, isDataLoaded, setIsDataLoaded, loading, loadDetailWithoutDate,loadDetailWithDate };
};

export default useGetMAWiseBalancePlanQty;